import axios from 'axios';
import {XHR_STATUS_DEFAULT} from '../../utils/portuna';

interface EditBlockOptions
{
    resource: string
    type: string
    id: number
    update?: number
}

let intervals: StringDynamicObject<number>                    = {};
let timeouts: StringDynamicObject<number>                     = {};
let editBlockInstances: StringDynamicObject<EditBlockHandler> = {};

if (process.env.NODE_ENV !== 'production')
{
    // @ts-ignore (only debug stuff)
    window.BLOCK_EDIT_INSTANCES = editBlockInstances;
}

export default class EditBlockHandler
{
    private _busy = false;

    private _options: EditBlockOptions;

    private readonly _identifier: string;

    constructor(options: EditBlockOptions)
    {
        options.update = options.update || 30;
        if (options.update < 10)
        {
            options.update = 10;
        }
        this._options    = options;
        this._identifier = this._options.resource + '_' + this._options.type;

        this.destroy();

        editBlockInstances[this._identifier] = this;
        intervals[this._identifier]          = window.setInterval(this._update.bind(this), (options.update - 5) * 1000);
    }

    public static destroy(resource: string, type: string)
    {
        let instance = editBlockInstances[resource + '_' + type];
        if (instance)
        {
            instance.destroy();
        }
    }

    public destroy()
    {
        // clear interval
        if (intervals[this._identifier])
        {
            window.clearInterval(intervals[this._identifier]);
            delete intervals[this._identifier];
        }

        // clear timeout
        if (timeouts[this._identifier])
        {
            window.clearTimeout(timeouts[this._identifier]);
            delete timeouts[this._identifier];
        }

        // delete instance
        delete editBlockInstances[this._identifier];
    }

    private _update()
    {
        if (this._busy)
        {
            return;
        }

        this._busy = true;
        axios.post('/ajax/block-edit', this._options)
        .catch(({data: {status}}) =>
        {
            if (status === XHR_STATUS_DEFAULT)
            {
                timeouts[this._identifier] = window.setTimeout(this._update.bind(this), 5000);
            }
        })
        .finally(() =>
        {
            this._busy = false;
        });
    }
}

export {
    editBlockInstances,
};